import dayjs from "dayjs";
import { defineComponent, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { api } from "~/api";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { NyukyoStatus, PageID } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import { store } from "../store/TaikyoStore";
import TaikyoButtonPanel from "./components/TaikyoButtonPanel.vue";
import { useLoad } from "./composition/Load";
const log = Log.create("Kaiyaku.guide");
export default defineComponent({
    name: "KaiyakuGuidePage",
    components: {
        TaikyoButtonPanel,
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["taikyo-flow-guide", "kaiyaku-entry", "kaiyaku-entry-hason", "kaiyaku-entry-check"];
        if (relatedScreens.includes(fromScreen)) {
            next();
            return;
        }
        next({ name: "taikyo" });
    },
    async setup() {
        const pageName = commonStore.pageName(PageID.kaiyakuGuide);
        const html = ref("");
        const visiblePanel = ref(false);
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const router = useRouter();
        const { load } = useLoad();
        const initView = async () => {
            try {
                html.value = await api.kaiyaku.loadTsuchiGuideText();
                if (!store.kaiyakuForInput.appliedInput) {
                    await load();
                }
                if ((store.taikyoEntity.status === NyukyoStatus.NotificationApproval || store.taikyoEntity.status === NyukyoStatus.ProvisionalLiquidation) &&
                    store.taikyoEntity.taikyoYmd !== null &&
                    typeof store.taikyoEntity.taikyoYmd !== "undefined") {
                    const taikyoBtnEnableYmd = dayjs(store.taikyoEntity.taikyoYmd).subtract(store.kaiyakuForInput.taikyoButtonShowDays, "day");
                    const today = dayjs(new Date());
                    if (taikyoBtnEnableYmd.isBefore(today) || taikyoBtnEnableYmd.isSame(today)) {
                        visiblePanel.value = true;
                    }
                }
            }
            catch (ex) {
                log.error("initView", ex);
                if (ex?.data?.status !== 404) {
                    MsgBox.error(ex?.message ?? "エラーが発生しました。");
                }
            }
        };
        await initView();
        return {
            pageName,
            html,
            visiblePanel,
            isMultipleKeiyaku,
            PageID,
            router,
            NyukyoStatus,
            ...toRefs(store)
        };
    }
});
